// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__DTD1A","button":"styles_button__3urEM"};